<template>
  <v-sheet rounded class="px-6 py-6">
    <ui-box-label class="mb-2">Vyberte zdroj publika</ui-box-label>
    <v-select
      outlined
      hide-details="auto"
      clearable
      placeholder="Vyberte stávající okruh uživatelů nebo zdroj dat"
      class="mb-6"
      :items="Object.values(lookalikeSources)"
      item-text="name"
      item-value="id"
      v-model="origin"
      return-object
      @input="isValid('origin')"
      :error-messages="getValidationsErrors('origin')"
    />
    <ui-box-label class="mb-2">Vyberte umístění publika</ui-box-label>
    <geo-location-input
      v-if="!!country"
      :value="country"
      @delete="country = null"
    />
    <geo-location-search
      geo-location-type="countries"
      :visible="!country"
      @select="country = $event"
    />
    <!--    <v-autocomplete-->
    <!--      outlined-->
    <!--      hide-details-->
    <!--      clearable-->
    <!--      prepend-inner-icon="mdi-magnify"-->
    <!--      placeholder="Hledejte země"-->
    <!--      class="mb-4"-->
    <!--    />-->
    <!--    <div class="mb-6">-->
    <!--      <v-btn-->
    <!--        small-->
    <!--        rounded-->
    <!--        text-->
    <!--        color="navy"-->
    <!--        class="ml-n2 font-weight-bold"-->
    <!--      >-->
    <!--        <v-icon left>-->
    <!--          mdi-plus-circle-outline-->
    <!--        </v-icon>-->
    <!--        Zahrnout další publikum-->
    <!--      </v-btn>-->
    <!--    </div>-->
    <ui-box-label class="mt-6">Vyberte velikost publika</ui-box-label>
    <!--    <div class="mb-4 body-1">-->
    <!--      Počet podobných publik-->
    <!--      <v-tooltip top color="primary">-->
    <!--        <template v-slot:activator="{ on, attrs }">-->
    <!--          <v-icon small v-bind="attrs" v-on="on" color="navy lighten-1">-->
    <!--            mdi-help-circle-->
    <!--          </v-icon>-->
    <!--        </template>-->
    <!--        Lorem ipsum-->
    <!--      </v-tooltip>-->
    <!--    </div>-->
    <!--    <div class="d-flex mb-8">-->
    <!--      <v-select-->
    <!--        class="shrink"-->
    <!--        outlined-->
    <!--        hide-details-->
    <!--        :items="[1, 2]"-->
    <!--        :value="1"-->
    <!--      />-->
    <!--    </div>-->
    <div>
      <v-range-slider
        class="c-slider--labels"
        color="info"
        track-color="navy lighten-2"
        :min="0"
        :max="10"
        :step="1"
        ticks
        :tick-labels="tickLabels"
        :tick-size="0"
        v-model="ratios"
      />
    </div>
  </v-sheet>
</template>

<script>
import { call, get, sync } from "vuex-pathify"
import { range } from "lodash"

import GeoLocationInput from "@/components/ui/targeting/GeoLocationInput"
import GeoLocationSearch from "@/components/ui/targeting/GeoLocationSearch"
import { required } from "vuelidate/lib/validators"
import validation from "../../../mixins/validation"

export default {
  name: "LookalikeAudience",
  components: {
    GeoLocationInput,
    GeoLocationSearch,
  },
  props: {
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  mixins: [validation],
  data() {
    return {
      tickLabels: range(11).map(n => `${n} %`),
      validationMessages: {
        origin: {
          required: "Toto pole je povinné",
        },
      },
    }
  },
  validations: {
    origin: {
      required,
    },
  },
  computed: {
    ...get("audiences", ["lookalikeSources"]),
    ratios: {
      get() {
        return [this.startingRatio * 100, this.ratio * 100]
      },
      set(val) {
        if (val !== this.ratios) {
          this.startingRatio = val[0] / 100
          this.ratio = val[1] / 100
        }
      },
    },
  },
  methods: {
    ...call("audiences", ["loadLookalikeSources"]),
  },
  mounted() {
    this.loadLookalikeSources()
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    if (!this.$options.computed) {
      this.$options.computed = {}
    }
    // if (!this.$options.methods) {
    //   this.$options.computed = {}
    // }

    Object.assign(this.$options.computed, {
      ...sync(`${storeNamespace}/model@audience.lookalikeSpec`, [
        "country",
        "origin",
        "ratio",
        "startingRatio",
      ]),
    })

    // Object.assign(this.$options.methods, {
    //   ...call(`${storeNamespace}`, [
    //     "includedAudienceAppend",
    //     "includedAudienceRemove",
    //     "includedAudienceUpdate",
    //     "excludedAudienceAppend",
    //     "excludedAudienceRemove",
    //     "excludedAudienceUpdate",
    //   ]),
    // })
  },
}
</script>
